import styled from 'styled-components'
import { List } from '@gympass/yoga'
import tokens from '@gympass/yoga-tokens'
import { Check } from '@gympass/yoga-icons'

export const EmployeeInvestmentWrapper = styled.section`
  padding-top: 20px;
`

export const Title = styled.h2`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  margin: 36px 0 0;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin: 52px 0 0;
  }
`

export const Subtitle = styled.h6`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  margin: 8px 0 0;
`

export const ListWrapper = styled.section`
  margin-top: 32px;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin-top: 48px;
  }
`

export const ListIcon = styled(Check)`
  margin-right: 8px;
  height: 24px;
  width: 24px;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    height: 24px;
  }
`

export const ListItem = styled(List.Item)`
  display: flex;
  margin-bottom: 16px;
  padding: 0;

  &:last-of-type {
    margin-bottom: 0px;
  }
`

export const ListItemDescription = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  margin: 0px;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    font-size: 16px;
  }
`

export const ButtonWrapper = styled.section`
  margin-top: 24px;
  margin-bottom: 64px;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin-top: 40px;
    margin-bottom: 72px;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-bottom: 88px;
  }
`

export const IllustrationWrapper = styled.section`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`
